import gql from 'graphql-tag'

export default gql`
  query getPassportFideliteSubscribers {
    getPassportFideliteSubscribers {
      id
      email
      created_at
      updated_at
      count
    }
  }
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/passportfidelite-subscriber/get.js